<template>
  <div class="bottom-footer-container">
    <p
      v-if="isStaffView"
      class="staff-view-banner"
    >
      STAFF VIEW: Viewing invoice for {{ customerName }}
    </p>
    <div class="bottom-disclaimer">
      If you have any questions, please contact us here:
      <a href="mailto:info@lelandlittle.com">info@lelandlittle.com </a>
    </div>
    <button @click="exit()">
      Exit
    </button>
  </div>
</template>

<script>
export default {
  name: "BottomFooterComponent",
  props: ["isStaffView", "exit", "customerName"],
};
</script>